import React, { lazy, Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { useLocation } from 'react-router-dom';
import loadingimg from '../src/images/logo.svg';
// import { BrowserRouter } from 'react-router-dom';

const App = lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <BrowserRouter basename="/newwebsite-2024/sysintelli-react/">
    <Suspense fallback={
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <img loading="lazy" src={loadingimg} alt="loading" width={250}/>
    </div>
    }>
      <App />
    </Suspense>
  // </BrowserRouter>
);

reportWebVitals();



